import { ControlType, FetchStatus, Property } from "../../../../../base/types";
import { ErrorMessage, ProgressIndicator } from "../../../../../widgets";
import { FC, useCallback } from "react";
import { TextAreaProperties, useTextAreaProperties } from "./TextAreaProperties";

import { DraftTextAreaComponent } from "./DraftTextAreaComponent";
import { IControlAttributes } from "../../../../../base/models";
import { InputLabel } from "../../InputLabel";
import { Registry } from "../../../../../base/register";
import { SimpleTextArea } from "./SimpleTextArea";
import { TextAreaField } from "./TextAreaField";

export const TextAreaComponent: FC<IControlAttributes> = ({
    control, className, props
}) => {
    const { status, properties, bindings, error } = useTextAreaProperties(props);
    const { label, required, title } = properties || {}
    const containerClass = label ? className : ''
    const inputClass = label ? '' : className

    const getTextArea = useCallback(() => {
        const binding = bindings?.getBinding(Property.InitValue);
        switch (binding?.type) {
            case "Field":
                return <TextAreaField
                    id={control.controlId}
                    name={binding.boundValue}
                    className={className}
                    {...properties}
                />
            case "Const":
            case "Expression":
                return <SimpleTextArea
                    id={control.controlId}
                    title={title}
                    {...properties}
                    className={inputClass}
                />
            default:
                return <></>
        }

        // eslint-disable-next-line
    }, [bindings, control])

    switch (status) {
        case FetchStatus.Idle: return <></>
        case FetchStatus.Loading: return <ProgressIndicator />
        case FetchStatus.Error: return <ErrorMessage message={error} />
    }

    return <InputLabel
        htmlFor={control.controlId}
        title={title}
        label={label}
        required={required}
        className={containerClass}>
        {getTextArea()}
    </InputLabel>
}

Registry.addControl({
    id: "ba6ca76c-1fed-4586-a39d-12874d283346",
    name: "Text Area",
    type: ControlType.TextArea,
    properties: TextAreaProperties,
    component: TextAreaComponent,
    draftComponent: DraftTextAreaComponent
})
